var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnplugged(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1920,
    height: 123.5,
    viewBox: "0 0 1920 123.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -862.193)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1915.6,1860.746h-31.838A13.764,13.764,0,0,1,1870,1846.982v-24.407a13.727,13.727,0,0,1,4.834-10.472h0a13.7,13.7,0,0,1,8.926-3.288H1915.6Z",
    transform: "translate(-1152.041 -910.836)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(756.396 862.193)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2051.479,1844.356h-63.6a17.785,17.785,0,0,1-17.783-17.787v-70.616a17.784,17.784,0,0,1,17.783-17.783h63.6Z",
    transform: "translate(-1970.099 -1729.512)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 123.5,
    height: 14.002,
    rx: 6.08,
    transform: "translate(81.379 123.5) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2218.488,1805.9v-18.1h43.281a9.048,9.048,0,0,1,9.049,9.048h0a9.049,9.049,0,0,1-9.049,9.048Z",
    transform: "translate(-2123.107 -1760.087)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.049,0h0A9.049,9.049,0,0,1,18.1,9.049V52.33a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V9.049A9.049,9.049,0,0,1,9.049,0Z",
    transform: "translate(147.711 77.686) rotate(90)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2051.479,1844.356h-63.6a17.785,17.785,0,0,1-17.783-17.787v-70.616a17.784,17.784,0,0,1,17.783-17.783c5.3,76.25,63.6,83.254,63.6,83.254Z",
    transform: "translate(-1213.702 -867.318)",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 106.186,
    height: 5.128,
    transform: "translate(837.775 870.852) rotate(90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2024.6,1906.64h-36.716a17.785,17.785,0,0,1-17.783-17.787V1839.28C1970.1,1889.34,2024.6,1906.64,2024.6,1906.64Z",
    transform: "translate(-1213.702 -929.602)",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 51.929,
    height: 3.324,
    transform: "translate(756.396 897.979) rotate(90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18.097,
    height: 6.336,
    transform: "translate(858.113 889.911) rotate(90)",
    fill: "#15172d"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18.097,
    height: 6.336,
    transform: "translate(858.113 939.879) rotate(90)",
    fill: "#15172d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1908.437,1866.02h-24.675A13.764,13.764,0,0,1,1870,1852.257V1827.85a13.727,13.727,0,0,1,4.834-10.472h0c-4.666,38.043,33.6,43.852,33.6,43.852Z",
    transform: "translate(-1152.041 -916.111)",
    fill: "#fff",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2971.246,1860.746h31.838a13.764,13.764,0,0,0,13.763-13.764v-24.407a13.727,13.727,0,0,0-4.834-10.472h0a13.7,13.7,0,0,0-8.926-3.288h-31.838Z",
    transform: "translate(-1830.409 -910.836)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1052.619 862.193)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2777.975,1844.356h63.6a17.785,17.785,0,0,0,17.783-17.787v-70.616a17.784,17.784,0,0,0-17.783-17.783h-63.6Z",
    transform: "translate(-2763.973 -1729.512)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 123.5,
    height: 14.002,
    rx: 6.08,
    transform: "translate(0 123.5) rotate(-90)",
    fill: "#070707"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2777.975,1844.356h63.6a17.785,17.785,0,0,0,17.783-17.787v-70.616a17.784,17.784,0,0,0-17.783-17.783c-5.3,76.25-63.6,83.254-63.6,83.254Z",
    transform: "translate(-1711.354 -867.318)",
    fill: "#fff",
    opacity: 0.32
  }), /*#__PURE__*/React.createElement("rect", {
    width: 106.186,
    height: 5.128,
    transform: "translate(1071.749 870.852) rotate(90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2847.975,1906.64h36.717a17.785,17.785,0,0,0,17.783-17.787V1839.28C2902.475,1889.34,2847.975,1906.64,2847.975,1906.64Z",
    transform: "translate(-1754.474 -929.602)",
    fill: "#fff",
    opacity: 0.13
  }), /*#__PURE__*/React.createElement("rect", {
    width: 51.929,
    height: 3.324,
    transform: "translate(1151.324 897.979) rotate(90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2989.9,1866.02h24.675a13.764,13.764,0,0,0,13.764-13.764V1827.85a13.727,13.727,0,0,0-4.834-10.472h0c4.667,38.043-33.6,43.852-33.6,43.852Z",
    transform: "translate(-1841.9 -916.111)",
    fill: "#fff",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("rect", {
    width: 717.958,
    height: 15.978,
    transform: "translate(0 915.956)",
    fill: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 733.561,
    height: 15.978,
    transform: "translate(1186.439 917.6)",
    fill: "#1f1f1f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnplugged);
export default __webpack_public_path__ + "static/media/unplugged.96ebc006586b478b170f0101aaec3173.svg";
export { ForwardRef as ReactComponent };